"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SharedContext = void 0;
var _console = require("../util/console");
const model = {
  agentIdentifier: '',
  ee: undefined
};
class SharedContext {
  constructor(context) {
    try {
      if (typeof context !== 'object') return (0, _console.warn)(8);
      this.sharedContext = {};
      Object.assign(this.sharedContext, model);
      Object.entries(context).forEach(([key, value]) => {
        if (Object.keys(model).includes(key)) this.sharedContext[key] = value;
      });
    } catch (err) {
      (0, _console.warn)(9, err);
    }
  }
}
exports.SharedContext = SharedContext;